import React, { useState, useEffect } from 'react';
import { orderService } from '../api/orderService';
import { productService } from '../api/productService';
import { clientService } from '../api/clientService';
import '../components/Common/Common.css';

function Dashboard() {
  const [stats, setStats] = useState({
    totalOrders: 0,
    totalProducts: 0,
    totalClients: 0,
    recentOrders: [],
  });
  const [loading, setLoading] = useState(true);

  const fetchDashboardData = async () => {
    try {
      setLoading(true);
      const [ordersRes, productsRes, clientsRes] = await Promise.all([
        orderService.getOrders({ per_page: 5 }),
        productService.getProducts({ per_page: 1 }),
        clientService.getClients({ per_page: 1 }),
      ]);

      setStats({
        totalOrders: ordersRes.meta?.total || 0,
        totalProducts: productsRes.meta?.total || 0,
        totalClients: clientsRes.meta?.total || 0,
        recentOrders: ordersRes.data || [],
      });
    } catch (error) {
      console.error('Error fetching dashboard data:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchDashboardData();
  }, []);

  if (loading) {
    return <div className="loading">Chargement du tableau de bord...</div>;
  }

  return (
    <div>
      <div className="page-header">
        <h1>Tableau de bord</h1>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '20px', marginBottom: '30px' }}>
        <div className="card">
          <div className="card-header">
            <h2>Total commandes</h2>
          </div>
          <div className="card-body">
            <h3 style={{ fontSize: '36px', margin: 0, color: '#3182ce' }}>{stats.totalOrders}</h3>
          </div>
        </div>

        <div className="card">
          <div className="card-header">
            <h2>Total produits</h2>
          </div>
          <div className="card-body">
            <h3 style={{ fontSize: '36px', margin: 0, color: '#38a169' }}>{stats.totalProducts}</h3>
          </div>
        </div>

        <div className="card">
          <div className="card-header">
            <h2>Total clients</h2>
          </div>
          <div className="card-body">
            <h3 style={{ fontSize: '36px', margin: 0, color: '#e53e3e' }}>{stats.totalClients}</h3>
          </div>
        </div>
      </div>

      <div className="card">
        <div className="card-header">
          <h2>Commandes récentes</h2>
        </div>
        <div className="card-body">
          {stats.recentOrders.length > 0 ? (
            <table className="data-table">
              <thead>
                <tr>
                  <th>ID</th>
                  <th>Client</th>
                  <th>Total</th>
                  <th>Statut</th>
                  <th>Date</th>
                </tr>
              </thead>
              <tbody>
                {stats.recentOrders.map((order) => (
                  <tr key={order.id}>
                    <td>{order.id}</td>
                    <td>{order.client ? `${order.client.first_name} ${order.client.last_name}` : order.guest_name}</td>
                    <td>{parseFloat(order.total).toFixed(2)} DH</td>
                    <td>
                      <span className={`badge badge-${order.status === 'completed' ? 'success' : 'info'}`}>
                        {order.status}
                      </span>
                    </td>
                    <td>{new Date(order.created_at).toLocaleDateString()}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          ) : (
            <p>Aucune commande récente</p>
          )}
        </div>
      </div>
    </div>
  );
}

export default Dashboard;
